module.exports = __webpack_public_path__ + "img/alerticon.5eb2925c.svg";